import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { integrationService } from '../services/integrations.service';

/**
 * Tipo para los proveedores obtenidos del método `getProviders`.
 */
export interface Provider {
    id: string;
    name: string;
    available: boolean;
    icon: string;
}

/**
 * Hook para obtener la lista de proveedores de integración.
 *
 * @returns Los proveedores y el estado de la consulta.
 */
export const useGetProviders = (appId?: string): UseQueryResult<Provider[], Error> => {
    return useQuery<Provider[], Error>({
        queryKey: ['providers'], // Clave única para la consulta
        queryFn: async () => {
            if (appId === undefined) {
                throw new Error('appId is required to fetch providers');
            }
            const providers = await integrationService.getProviders(appId as string);
            return providers;
        },
        enabled: !!appId, // Habilita la consulta solo si appId está definido
    });
};
